import { toRefs, ref, computed, watch, onMounted } from 'vue';
import tinycolor from 'tinycolor2';
import ProfileBtn from '../../btn/component-lib.esm3.js';
import { useTypeform } from '../../../compositions/component-lib.esm10.js';
import { getTypeformId } from '../../../utils/embed/component-lib.esm4.js';
import { useTheme } from '../../../compositions/component-lib.esm7.js';

//
var script = {
  components: {
    ProfileBtn
  },
  props: {
    url: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      default: null
    },
    formOptions: {
      type: Object,
      required: true
    },
    imageStyle: String,
    btnSize: String,
    variant: String,
    btnProps: Object
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      url,
      formOptions
    } = toRefs(props);
    const formRef = ref(null);
    const widget = ref(null);
    const oldFormOptions = ref(formOptions.value);
    const {
      typeform,
      hasLoadedPromise
    } = useTypeform();
    const theme = useTheme();
    const typeformId = computed(() => {
      return getTypeformId(url.value);
    });
    const isWidget = computed(() => {
      return formOptions.value.layout === 'standard';
    });
    const height = computed(() => {
      return `${formOptions.value.height}px`;
    });
    const styles = computed(() => {
      // Make video container background a solid color
      let bgColor = theme.value.profile.btnBgColor;
      if (bgColor === 'transparent') bgColor = '#000';
      return {
        height: height.value,
        '--c-bg-color': tinycolor(bgColor).setAlpha(1).toString()
      };
    });
    async function loadCSS() {
      try {
        switch (formOptions.value.layout) {
          case 'standard':
            require('@typeform/embed/build/css/widget.css');
            break;
          case 'popup':
            require('@typeform/embed/build/css/popup.css');
            break;
          case 'slider':
            require('@typeform/embed/build/css/slider.css');
            break;
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    }
    async function createTypeform() {
      await hasLoadedPromise;
      if (widget.value && widget.value.unmount) widget.value.unmount();
      switch (formOptions.value.layout) {
        case 'standard':
          widget.value = typeform.value.createWidget(typeformId.value, {
            container: formRef.value,
            disableAutoFocus: true,
            height: height.value,
            onSubmit() {
              emit('form-submit');
            }
          });
          break;
        case 'popup':
          widget.value = typeform.value.createPopup(typeformId.value, {
            onSubmit() {
              emit('form-submit');
            }
          });
          break;
        case 'slider':
          widget.value = typeform.value.createSlider(typeformId.value, {
            onSubmit() {
              emit('form-submit');
            }
          });
          break;
      }
    }

    // Make sure css is loaded for each form type
    watch(formOptions, () => {
      loadCSS();
    }, {
      immediate: true
    });
    onMounted(async () => {
      if (isWidget.value) {
        createTypeform();
      }
    });
    watch(formOptions, () => {
      if (JSON.stringify(formOptions.value) !== JSON.stringify(oldFormOptions.value)) createTypeform();
      oldFormOptions.value = formOptions.value;
    });
    async function handleClick() {
      if (!widget.value) await createTypeform();
      widget.value.toggle();
      emit('click');
    }
    return {
      formRef,
      styles,
      isWidget,
      handleClick
    };
  }
};
export { script as default };